module.exports = __webpack_public_path__ + "img/arrow_top_icon.0684626d.svg";